import {LoginBackgroundSvg} from '@sollapay/ui/components';

import type {FC, ReactNode} from 'react';

interface LoginBackgroundProps {
  children?: ReactNode;
  background?: ReactNode;
}

export const LoginBackground: FC<LoginBackgroundProps> = ({
  children,
  background = <LoginBackgroundSvg />
}) => {
  return (
    <div
      dir="rtl"
      className="relative flex min-h-screen items-center justify-center bg-background p-6 sm:justify-start sm:px-[6vw]"
    >
      {background}
      {/* Same spot as the Auth0 login widget (sollapay-auth0 universal_login.html): a 420px box centred at ~77vw. */}
      <div className="relative z-10 sm:mr-[max(0px,calc(17vw-210px))]">{children}</div>
    </div>
  );
};
